import Vue from 'vue'

export async function searchProducts ({ commit }, { search, searchConfig }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setSearch', search)
    commit('setSearchConfig', searchConfig)
    commit('setProducts', null)

    const url = buildSearchURL('/v1/products', search, searchConfig)
    const { data } = await Vue.axios({
      url
    })

    commit('setProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getMoreProducts ({ commit }, url) {
  try {
    commit('shared/setError', null, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      url
    })

    commit('addProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getProduct ({ commit }, slug) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setProduct', null)

    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/products/${slug}`
    })

    commit('setProduct', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

function buildSearchURL (baseURL, search, searchConfig = undefined) {
  search = encodeURIComponent(search)
  let url = `${baseURL}?search=${search}`

  if (searchConfig) {
    url = url + '&' + searchConfigToURL(searchConfig)
  }

  return url
}

function searchConfigToURL (searchConfig) {
  return Object.keys(searchConfig).map(key => {
    const configValue = searchConfig[key]
    if (!Array.isArray(configValue)) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(configValue)
    }

    const configs = []
    for (var value of configValue) {
      configs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
    }

    return configs.join('&')
  }).join('&')
}

export async function getHomeProducts ({ commit }) {
  try {
    commit('shared/setError', null, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setHomeProducts', null)

    const { data } = await Vue.axios({
      method: 'GET',
      url: '/v1/products/home'
    })

    commit('setHomeProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
